export default function SubscriberState (state = {
    subscriber: { search_string: '', list:{}, details:{}, validation:{}, options:{}, filter: {}}
    }, action) {
    switch(action.type) {
        case 'SUBSCRIBER_UPDATE_SEARCH_STRING':
            state.subscriber.search_string = action.value;
            return { ...state };
        case "SUBSCRIBER_UPDATE_FILTER_STRING":
            state.subscriber.filter = action.value;
            return { ...state };
        case 'SUBSCRIBER_SEARCH':
            state.subscriber.list = action.data.list;
            return { ...state };
        case 'SUBSCRIBER_OPTIONS':
            state.subscriber.options = action.data.options;
            return { ...state };
        case 'SUBSCRIBER_DETAILS':
            state.subscriber.details = action.data.record;
            return { ...state };
        case 'SUBSCRIBER_UPDATE_FORM':
            state.subscriber.details[action.field] = action.value;
            if (state.subscriber.validation[action.field]) {
                state.subscriber.validation[action.field] = {};
            }
            return { ...state };
        case 'SUBSCRIBER_VALIDATION_ERROR':
            state.subscriber.validation = action.data;
            return { ...state };
        case 'SUBSCRIBER_SELECTED':
            state.subscriber.selected = action.value;
            state.subscriber.details = {};
            state.subscriber.validation = {};
            return { ...state };
        case 'SUBSCRIBER_DESELECTED':
        case 'SUBSCRIBER_UPDATED':
        case 'SUBSCRIBER_INSERTED':
        case 'SUBSCRIBER_DELETED':
            state.subscriber.selected = null;
            state.subscriber.details = {};
            state.subscriber.validation = {};
            return { ...state };
        case 'SUBSCRIBER_CANCEL_SELECT':
            state.subscriber.selected = null;
            return { ...state };
        case 'SUBSCRIBER_INSERT_ERROR':
        case 'SUBSCRIBER_UPDATE_ERROR':
            state.subscriber = {};
            return { ...state };
        default:
            break;
    }
    return state;
}

